module.exports = __webpack_public_path__ + "img/img_user-default.4b7a35d0.svg";